import { cloneDeep } from 'lodash';

import { CommunicationTask } from '../../generic/communication-task/communication-task';
import { CommunicationTaskSchema } from '../../generic/communication-task/communication-task-schema';
import { CommunicationTaskName } from '../../generic/communication-task-name';

import { CommunicationTaskConversationRequestConstructor } from './communication-task-conversation-request-constructor';
import { CommunicationTaskConversationRequestSchema } from './communication-task-conversation-request-schema';

export class CommunicationTaskConversationRequest extends CommunicationTask {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected conversationConfigId!: string;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: CommunicationTaskConversationRequestConstructor) {
    super(
      Object.assign(parameters, {
        [CommunicationTaskSchema.type]: CommunicationTaskName.conversationRequest,
      }),
    );
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(
    validationResult: import('joi').ValidationResult,
  ): CommunicationTaskConversationRequest {
    return new CommunicationTaskConversationRequest(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(CommunicationTaskConversationRequest.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): CommunicationTaskConversationRequestSchema {
    return new CommunicationTaskConversationRequestSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getConversationConfigId(): string {
    return cloneDeep(this.conversationConfigId);
  }
}
